import {SearchContainer} from '../core/definitions/search-container';
import {SearchResultViewType} from '../core/definitions/search-result-view-type.enum';
import {AConst} from '../core/a-const.enum';

export const CONTENT_LIST_FIELD_TEMPLATE_GROUP_ID = 'list_content_view_dropdown';

export interface ContentListFieldTemplateResult {
  object_type?: string;
  template_group_id?: string;
}

export interface ContentListFieldTemplateActions {
  setListFieldTemplateGroup(searchContainer: SearchContainer, templateGroupId: string): Promise<void>;
  clearListFieldTemplate(searchContainer: SearchContainer): void;
  reloadOverview(): Promise<void>;
  navigateToSearch?(): Promise<void>;
  rememberChoice?(searchContainer: SearchContainer): void;
}

export async function applyContentListFieldTemplateResult(
  searchContainer: SearchContainer,
  resultObject: ContentListFieldTemplateResult | null | undefined,
  actions: ContentListFieldTemplateActions,
): Promise<boolean> {
  if (resultObject?.object_type !== AConst.OBJECT_TYPE_TEMPLATE_MODEL_OVERVIEW_FIELDS_FOR_FIELD_SELECT) {
    return false;
  }
  searchContainer.refreshTemplateOverviewFields = true;
  const pageSize = contentListPageSize(searchContainer);
  if (resultObject.template_group_id) {
    try {
      await actions.setListFieldTemplateGroup(searchContainer, resultObject.template_group_id);
    } catch (error) {
      console.warn('Could not switch the content list to the new fields', error);
    }
    restoreContentListPageSize(searchContainer, pageSize);
  } else {
    actions.clearListFieldTemplate(searchContainer);
  }
  actions.rememberChoice?.(searchContainer);
  await actions.reloadOverview();
  return true;
}

export async function clearContentListFieldTemplate(
  searchContainer: SearchContainer,
  actions: ContentListFieldTemplateActions,
): Promise<void> {
  searchContainer.refreshTemplateOverviewFields = true;
  actions.clearListFieldTemplate(searchContainer);
  actions.rememberChoice?.(searchContainer);
  await actions.reloadOverview();
}

function contentListPageSize(searchContainer: SearchContainer): number | undefined {
  const rows = searchContainer.rows;
  if (!rows || typeof rows === 'number') {
    return undefined;
  }
  const cardRows = rows[SearchResultViewType.CONTENT_LIST];
  if (typeof cardRows === 'number') {
    return cardRows;
  }
  const listRows = rows[SearchResultViewType.LIST];
  return typeof listRows === 'number' ? listRows : undefined;
}

export function showsSelfHostedFieldSelector(
  container: { hostsOwnSelector?: boolean; selectorEnabled?: boolean } | null | undefined,
): boolean {
  return container?.hostsOwnSelector === true && container.selectorEnabled === true;
}

export function pageRendersSelector(
  container: { hostsOwnSelector?: boolean } | null | undefined,
): boolean {
  return !!container && container.hostsOwnSelector !== true;
}

function restoreContentListPageSize(searchContainer: SearchContainer, pageSize: number | undefined): void {
  const rows = searchContainer.rows;
  if (typeof pageSize !== 'number' || !rows || typeof rows === 'number') {
    return;
  }
  rows[SearchResultViewType.LIST] = pageSize;
}
